/**
 * @generated SignedSource<<7412dfdf9010a377d9ac591ce40c4a59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AlertsMenuItemContentNew$data = {
  readonly opsgenie: {
    readonly savedSearches: {
      readonly createdByMe: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
      readonly sharedWithMe: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
      readonly starred: ReadonlyArray<{
        readonly alertSearchQuery: string;
        readonly id: string;
        readonly name: string;
      }>;
    };
  };
  readonly " $fragmentType": "AlertsMenuItemContentNew";
} | null;
export type AlertsMenuItemContentNew$key = {
  readonly " $data"?: AlertsMenuItemContentNew$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertsMenuItemContentNew">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "RequiredField",
    "field": {
      "kind": "ScalarField",
      "name": "id"
    },
    "action": "THROW"
  },
  {
    "kind": "RequiredField",
    "field": {
      "kind": "ScalarField",
      "name": "name"
    },
    "action": "THROW"
  },
  {
    "kind": "RequiredField",
    "field": {
      "kind": "ScalarField",
      "name": "alertSearchQuery"
    },
    "action": "THROW"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "AlertsMenuItemContentNew",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "OpsgenieQuery",
        "kind": "LinkedField",
        "name": "opsgenie",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "OpsgenieSavedSearches",
              "kind": "LinkedField",
              "name": "savedSearches",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "starred",
                    "plural": true,
                    "selections": (v0/*: any*/)
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "sharedWithMe",
                    "plural": true,
                    "selections": (v0/*: any*/)
                  },
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "createdByMe",
                    "plural": true,
                    "selections": (v0/*: any*/)
                  },
                  "action": "THROW"
                }
              ]
            },
            "action": "LOG"
          }
        ]
      },
      "action": "LOG"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "bd4e1308e60d32924440a27f61ed4f9a";

export default node;
